
export default {
  components: {},
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    stepsNew() {
      return this.steps.slice().reverse()
    }
  },

  created() {},
  mounted() {},

  methods: {}
}
